import { useEffect } from 'react';

import { useSetAtom } from 'jotai/react';

import { quickSlotCategoryAtom } from 'src/stores/auth/atoms';
import type { InventoryItemCategoryId } from 'src/types/itemInventory';

export default function useQuickSlotPage(categoryId: InventoryItemCategoryId): void {
  const setQuickSlotCategory = useSetAtom(quickSlotCategoryAtom);

  useEffect(() => {
    setQuickSlotCategory(categoryId);

    return () => {
      setQuickSlotCategory(null);
    };
  }, [categoryId, setQuickSlotCategory]);
}
